import { render, staticRenderFns } from "./ChargebackManagement.vue?vue&type=template&id=7b7df19e"
import script from "./ChargebackManagement.vue?vue&type=script&lang=js"
export * from "./ChargebackManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports